import axios from "axios";
import { LetterTemplateModel } from "./models";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type ListLetterTemplatesResponse = {
  letterTemplates: LetterTemplateModel[];
};

export const listLetterTemplates = async () => {
  const response = await executeApiRequest(() => axios.get<ListLetterTemplatesResponse>("/lettertemplates"));

  return response?.data.letterTemplates;
};
